
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.306 11.412"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_29875","data-name":"Path 29875","d":"M7.322 2.116L5.984.778A.947.947 0 005.314.5H1.92A1.42 1.42 0 00.5 1.92v7.573a1.42 1.42 0 001.42 1.42h9.466a1.42 1.42 0 001.42-1.42v-5.68a1.42 1.42 0 00-1.42-1.42H7.991a.947.947 0 01-.669-.278z","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1"}})])
          )
        }
      }
    